import React from 'react';
import clsx from 'clsx';
import { useCallback } from 'react';
import { ChannelPreviewUIComponentProps, useChatContext } from 'stream-chat-react';

import { DirectMessagingChannelPreview } from './DirectMessagingChannelPreview';
import { TeamChannelPreview } from './TeamChannelPreview';

import { useWorkspaceController } from '../../context/WorkspaceController';

import type { StreamChatType } from '../../types';

type TeamChannelPreviewProps = ChannelPreviewUIComponentProps<StreamChatType> & {
  type: string;
};

export const ChannelPreview = ({ channel }: TeamChannelPreviewProps) => {
  const { channel: activeChannel, setActiveChannel } = useChatContext<StreamChatType>();
  const { displayWorkspace } = useWorkspaceController();

  const handleClick = useCallback(() => {
    displayWorkspace('Chat');
    if (setActiveChannel) {
      setActiveChannel(channel);
    }
  }, [channel, displayWorkspace, setActiveChannel])

  const channelName = (channel?.data?.name as string | undefined)
    || (channel?.data?.id as string | undefined)
    || 'random';
  const channelImage = channel?.data?.image as string | undefined;
  const lastMessageDate = channel?.data?.last_message_at as (Date | string | number | null | undefined);
  const unreadCount = channel?.state?.unreadCount ?? 0;

  return (
    <button
      type='button'
      className={clsx('channel-preview', {selected: channel?.id === activeChannel?.id})}
      onClick={handleClick}
    >
      {channel && channel.type === 'team'
        ? (
          <TeamChannelPreview
            name={channelName}
            unreadCount={unreadCount}
            image={channelImage}
            lastMessageDate={lastMessageDate ?? undefined}
          />
        )
        : <DirectMessagingChannelPreview channel={channel} />
      }
    </button>
  );
};
